module.exports = __webpack_public_path__ + "img/Sarah.4c4d9314.svg";